var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CcGoods',{attrs:{"component":_vm.component,"context":_vm.context,"show-main":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }